
import React from "react";
import { checkSession, getBrand, setFavicon } from "../lib/functions";
import Header from "./Header.js";
import Login from "./Login.js";
import FadeIn from "./Fadein.js";
import Main from "./Main.js";
import { Fragment } from "react";

export default class Application extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
      brand: {},
      sessionChecked: false,
      student: ""
    };
  }


  /**
 * React lifecycle method. - OUTDATED WE NEED TO USE USEEFFECT INSTEAD
 * On mount, retrieves brand information, sets it in state, checks for an existing user session,
 * updates authentication state, and sets the favicon.
 */

  componentDidMount = () => {
    const brand = getBrand();
    this.setState({ brand: brand });
    checkSession((data) => {

      let valid = data.valid;

      this.setState({ loggedIn: valid, sessionChecked: true });
      if (valid) this.setState({ student: data });

    });
    setFavicon(brand.favicon);
  };

  /**
 * Callback to update state when a user successfully logs in.
 * @param {Object} student - The student/user data returned after login.
 */
  loggedIn = (student) => {
    this.setState({ loggedIn: true, student: student });
  };

  /**
 * Opens a help URL in a new browser tab if the triggering element has a 'data-url' attribute.
 * @param {Event} e - The event object from the click handler.
 */
  gethelp = (e) => {
    let url = e.currentTarget.getAttribute('data-url');
    if (url) window.open(url);

  };

  /**
 * Renders the application UI.
 * Shows the login screen if not authenticated, otherwise shows the main content.
 * @returns {JSX.Element}
 */
  render() {
    return (
      <Fragment>

        {!this.state.loggedIn && this.state.sessionChecked ?
          <>
            <Header student={this.state.student} gethelp={this.gethelp} />
            <FadeIn>
              <Login loggedIn={this.loggedIn} gethelp={this.gethelp} />
            </FadeIn>
          </>
          : null
        }
        {this.state.loggedIn && this.state.sessionChecked ?
          <Main student={this.state.student} gethelp={this.gethelp} />
          : null}
      </Fragment>
    );
  }
}
